/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Camera_No_ImageInputs */

const vi_vehicle_camera_no_image = /** @type {(inputs: Vehicle_Camera_No_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có ảnh camera mới nhất`)
};

/**

* @param {Vehicle_Camera_No_ImageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_camera_no_image = /** @type {((inputs?: Vehicle_Camera_No_ImageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Camera_No_ImageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_camera_no_image(inputs)
});